/**
 * fieldsets.jsx
 * 
 * Fieldset components for dialog entry 
 * 
 **/ 
import React, { Fragment, useState, useRef, useEffect } from 'react'

const RegisterFieldset = ({ stateChangeCallback }) => {
  const nameInput = useRef(null)
  const emailInput = useRef(null)
  const passwordInput = useRef(null)
  const confirmInput = useRef(null)
  const debounceTimeout = useRef(null)

  const handleChange = () => {
    clearTimeout(debounceTimeout.current)
    debounceTimeout.current = setTimeout(() => {
      const name = nameInput.current.value
      const email = emailInput.current.value
      const password = passwordInput.current.value
      const confirmed = confirmInput.current.value

      stateChangeCallback({ name, email, password, confirmed })      
    })
  }

  return <Fragment>
    <div className="field">
      <label className="label" htmlFor="name-input">Name:</label>
      <div className="control">
        <input type="text"
               className="input"
               id="name-input"
               ref={nameInput}
               onChange={handleChange} />
      </div>
    </div>
    <div className="field">
      <label className="label"
             htmlFor="login-email">Email:</label>
      <div className="control">
        <input type="email"
               className="input"
               id="login-email"
               ref={emailInput}
               onChange={handleChange} />
      </div>
    </div>
    <div className="field">
      <label className="label"
             htmlFor="login-pw">Password:</label>
      <div className="control">
        <input type="password"
               className="input"
               id="login-pw"
               ref={passwordInput}
               onChange={handleChange} />
      </div>
    </div>
    <div className="field">
      <label className="label"
             htmlFor="login-pw-confirm">Confirm Password:</label>
      <div className="control">
        <input type="password"
               className="input"
               id="login-pw-confirm"
               ref={confirmInput}
               onChange={handleChange} />
      </div>
    </div>
  </Fragment>
}

const LoginFieldset = ({ actionCallback,
                         closeModalCallback,
                         resetCallback,
                         stateChangeCallback }) => {
  const emailInput = useRef(null)
  const passwordInput = useRef(null)

  const debounceTimeout = useRef(null)

  const handleKeyDown = (event) => {
    switch (event.key) {
      case 'Escape':
        closeModalCallback()
        break
      case 'Enter':
        actionCallback()
        break
    }
  }

  const handleChange = (event) => {
    clearTimeout(debounceTimeout.current)
    debounceTimeout.current = setTimeout(() => {
      const password = passwordInput.current?.value
      const email = emailInput.current?.value

      stateChangeCallback({ password, email })      
    }, 150)
  }

  return <Fragment>
    <div className="field">
      <label className="label"
             htmlFor="login-username">Email:</label>
      <div className="control">
        <input type="email"
               className="input"
               id="login-email"
               ref={emailInput}
               onChange={handleChange}
               onKeyDown={handleKeyDown} />
      </div>
    </div>
    <div className="field">
      <label className="label" htmlFor="login-password">Password:</label>
      <div className="control">
        <input type="password"
               className="input"
               id="login-password"
               ref={passwordInput}
               onChange={handleChange}
               onKeyDown={handleKeyDown} />
      </div>
    </div>
    <div className="field">
      <label className="label" htmlFor="login-password">Forgot your password?</label>
      <div className="control">
        <button
          className="button"
          onClick={resetCallback}
          >Reset password</button>
      </div>
    </div>
  </Fragment>
}

const ForgotPasswordFieldset = ({ stateChangeCallback }) => {
  const emailInput = useRef(null)
  const debounceTimeout = useRef(null)

  const handleChange = () => {
    clearTimeout(debounceTimeout.current)
    debounceTimeout.current = setTimeout(() => {
      const email = emailInput.current?.value

      stateChangeCallback({ email })
    }, 150)
  }

  return <Fragment>
    <div className="field">
      <label className="label"
             htmlFor="login-username">Email:</label>
      <div className="control">
        <input type="email"
               className="input"
               id="login-username"
               ref={emailInput}
               onChange={handleChange} />
      </div>
    </div>
  </Fragment>
}

const OneTimePasswordFieldset = ({ stateChangeCallback, resetCallback }) => {
  const oneTimePasswordInput = useRef(null)
  const debounceTimeout = useRef(null)

  const handleChange = () => {
    clearTimeout(debounceTimeout.current)
    debounceTimeout.current = setTimeout(() => {
      const password = oneTimePasswordInput.current.value

      stateChangeCallback({ password })
    })
  }

  return <Fragment>
    <div className="field">
      <label className="label"
             htmlFor="otp-password">Code:</label>
      <div className="control">
        <input type="text"
               className="input"
               id="otp-password"
               ref={oneTimePasswordInput}
               onChange={handleChange} />
        <div className='mt-2'>
          Didn't receive the code?
          <button className='button mx-2' onClick={resetCallback} >Request new one-time password</button></div>
      </div>
    </div>
  </Fragment>
}

export { RegisterFieldset, LoginFieldset, ForgotPasswordFieldset, OneTimePasswordFieldset }